import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import SideNavbar from '../../core/components/sidebar/SideNavbar'
// import DashboardSidebar from '../../core/components/sidebar/DashboardSidebar'

export default function DashboardLayout() {
  return (
    <>
      <ToastContainer />
      <div className="flex min-h-screen w-full bg-muted-200">
        <SideNavbar />
        <div className="flex w-full flex-col gap-2 p-2">
          <Outlet />
        </div>
      </div>
    </>
  )
}
